module.exports = __webpack_public_path__ + "static/kic-digital-6b2baf1e7e20ddb94cd5fbcf2026259c.png";